import {Axios} from '../axios/axios.js'
//pretask list
export const preTaskList = (e) => {
  return Axios({
    url:'/PreTask/get_pre_task_list',
    method:"put",
    data:e
  })
}
//新增
export const addPreTask = (e) => {
  return Axios({
    url:'/PreTask/add_pre_task',
    method:"put",
    data:e
  })
}
//删除
export const delPreTask = (e) => {
  return Axios({
    url:'/PreTask/del_pre_task',
    method:"put",
    data:e
  })
}
//编辑
export const editPerTask = (e) => {
  return Axios({
    url:'/PreTask/edit_pre_task',
    method:"put",
    data:e
  })
}
//上传
export const uploadPerTask = (e) => {
  return Axios({
    url:'/PreTask/expore_pre_task',
    method:"post",
    headers: {
      // "content-type": "multipart/form-data",
      Accept: "application/json; charset=utf-8",
    },
    data:e,
  })
}
//气泡
export const getPreBubble = (e) => {
  return Axios({
    url:'/index.php/PreTask/get_pre_bubble',
    method:"put",
    data:e,
  })
}
//预创建任务指派
export const scanPreTask = (e) => {
  return Axios({
    url:'/PreTask/scan_pre_task',
    method:"put",
    data:e,
  })
}
//手动激活任务
export const activeManual = (e) => {
  return Axios({
    url:"/PreTask/manually_pre_task",
    method:'PUT',
    data :e
  })
}
//手动选择地区
export const activeManualZone = (e) => {
  return Axios({
    url:"/PreTask/active_pre_task",
    method:'PUT',
    data :e
  })
}
//单个打印
export const singlePrint = (e) => {
  return Axios({
    url:"/PreTask/single_print_task",
    method:'PUT',
    data :e
  })
}

//多个打印
// /PreTask/batch_print_task
export const batchPrint = (e) => {
  return Axios({
    url:"/PreTask/batch_print_task",
    method:'PUT',
    data :e
  })
}
//track 状态
export const getTrackData = (e) => {
 return Axios({
   url:'home_page/search_tracking_no',
   method:'PUT',
   data:e
 })
}
